// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.k-grid-header{
    padding-inline-end: 0 !important;
}

.k-grid-content{
    overflow: auto !important;
    overflow-y: auto !important;
}

tr{
  cursor: pointer;
}

tbody tr:nth-child(even) {
  background-color:var(--grid-even-color) !important;
}

tbody tr:nth-child(odd) {
  background-color:var(--grid-odd-color) !important;
}


tbody tr:hover {
  background-color:var(--even-row-hover) !important;
  transition: background-color 0.2s ease;
}

 tbody tr.k-selected {
  background-color: var(--selecte-row-color) !important;
  color: white !important;
  font-weight: bold !important;
}


.k-table-thead{
  background-color: var(--grid-header-color) !important;
  font-weight: bold;
  font-size: 16px;
}

.k-grid tbody tr:hover td {
  border-top: 1px solid var(--selecte-row-color);
  border-bottom: 1px solid var(--selecte-row-color);
}

.k-grid tbody tr:hover td:first-child {
  border-left: 1px solid var(--selecte-row-color);
}

.k-grid tbody tr:hover td:last-child {
  border-right: 1px solid var(--selecte-row-color);
}


.k-grid tbody tr {
  transition: box-shadow 0.2s ease;
}

.k-grid tbody tr:hover {
  box-shadow: inset 0 0 0 1px var(--selecte-row-color);
  color:black;
  font-weight: bold;
}

.k-column-title{
  font-size: 14px !important;
}




/* Scrollbar width */
.k-grid-content::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

/* Track */
.k-grid-content::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.k-grid-content::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 6px;
}

/* Handle on hover */
.k-grid-content::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.k-grid-content::-webkit-scrollbar {
  width: 6px;
}

.k-grid-content::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 10px;
}


.k-grid-header {
  position: sticky;
  top: 0;
  z-index: 10;
  background: white;
}


.k-grid td.k-selected,
.k-grid .k-table-row.k-selected > td,
.k-grid .k-table-td.k-selected,
.k-grid .k-table-row.k-selected > .k-table-td {
    background-color:transparent !important;
}


.k-table-tbody .k-table-row.k-selected > .k-table-td,
.k-table-list .k-table-row.k-selected {
    background-color:transparent !important;
}`, "",{"version":3,"sources":["webpack://./src/components/grid/grid.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,iDAAiD;AACnD;;;AAGA;EACE,iDAAiD;EACjD,sCAAsC;AACxC;;CAEC;EACC,qDAAqD;EACrD,uBAAuB;EACvB,4BAA4B;AAC9B;;;AAGA;EACE,qDAAqD;EACrD,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,8CAA8C;EAC9C,iDAAiD;AACnD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,gDAAgD;AAClD;;;AAGA;EACE,gCAAgC;AAClC;;AAEA;EACE,oDAAoD;EACpD,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;;;;AAKA,oBAAoB;AACpB;EACE,UAAU;EACV,WAAW;AACb;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;;AAGA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,iBAAiB;AACnB;;;AAGA;;;;IAII,uCAAuC;AAC3C;;;AAGA;;IAEI,uCAAuC;AAC3C","sourcesContent":[".k-grid-header{\n    padding-inline-end: 0 !important;\n}\n\n.k-grid-content{\n    overflow: auto !important;\n    overflow-y: auto !important;\n}\n\ntr{\n  cursor: pointer;\n}\n\ntbody tr:nth-child(even) {\n  background-color:var(--grid-even-color) !important;\n}\n\ntbody tr:nth-child(odd) {\n  background-color:var(--grid-odd-color) !important;\n}\n\n\ntbody tr:hover {\n  background-color:var(--even-row-hover) !important;\n  transition: background-color 0.2s ease;\n}\n\n tbody tr.k-selected {\n  background-color: var(--selecte-row-color) !important;\n  color: white !important;\n  font-weight: bold !important;\n}\n\n\n.k-table-thead{\n  background-color: var(--grid-header-color) !important;\n  font-weight: bold;\n  font-size: 16px;\n}\n\n.k-grid tbody tr:hover td {\n  border-top: 1px solid var(--selecte-row-color);\n  border-bottom: 1px solid var(--selecte-row-color);\n}\n\n.k-grid tbody tr:hover td:first-child {\n  border-left: 1px solid var(--selecte-row-color);\n}\n\n.k-grid tbody tr:hover td:last-child {\n  border-right: 1px solid var(--selecte-row-color);\n}\n\n\n.k-grid tbody tr {\n  transition: box-shadow 0.2s ease;\n}\n\n.k-grid tbody tr:hover {\n  box-shadow: inset 0 0 0 1px var(--selecte-row-color);\n  color:black;\n  font-weight: bold;\n}\n\n.k-column-title{\n  font-size: 14px !important;\n}\n\n\n\n\n/* Scrollbar width */\n.k-grid-content::-webkit-scrollbar {\n  width: 4px;\n  height: 4px;\n}\n\n/* Track */\n.k-grid-content::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n/* Handle */\n.k-grid-content::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 6px;\n}\n\n/* Handle on hover */\n.k-grid-content::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.k-grid-content::-webkit-scrollbar {\n  width: 6px;\n}\n\n.k-grid-content::-webkit-scrollbar-thumb {\n  background-color: #ccc;\n  border-radius: 10px;\n}\n\n\n.k-grid-header {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background: white;\n}\n\n\n.k-grid td.k-selected,\n.k-grid .k-table-row.k-selected > td,\n.k-grid .k-table-td.k-selected,\n.k-grid .k-table-row.k-selected > .k-table-td {\n    background-color:transparent !important;\n}\n\n\n.k-table-tbody .k-table-row.k-selected > .k-table-td,\n.k-table-list .k-table-row.k-selected {\n    background-color:transparent !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
